import {
  CLEAR_USER_ACCESS_CODE_SUCCESS,
  DELETE_USER_SUCCESS,
  GET_USERS_GROUPS_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_PATIENT_INFO_SUCCESS,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  REMOVE_SIMPLIFED_PATIENT_ID_SUCCESS,
  SEARCH_USERS_FAILURE,
  SEARCH_USERS_REQUEST,
  SEARCH_USERS_SUCCESS,
  TOGGLE_USER_FLAG_REQUEST,
  TOGGLE_USER_FLAG_SUCCESS,
} from './users.actions';
import { arrayPatch } from '../../utilities/arrayUtils';
import Immutable from 'immutable';

const initialState = Immutable.Map({
  users: [],
  totalCount: 0,
  isLoading: false,
  isToggling: false,
  errors: [],
  selectedUser: null,
});

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_USER_REQUEST:
      return state.set('isLoading', true).set('errors', []);

    case GET_USER_SUCCESS:
      return state.set('selectedUser', action.response).set('isLoading', false);

    case GET_USER_FAILURE:
      return state.set('isLoading', false).set('errors', action.messages);

    case SEARCH_USERS_SUCCESS:
      return state
        .set('users', action.response.items)
        .set('totalCount', action.response.metadata.total)
        .set('isLoading', false);

    case SEARCH_USERS_FAILURE:
      return state.set('errors', action.messages).set('isLoading', false);

    case SEARCH_USERS_REQUEST:
      return state.set('errors', []).set('isLoading', true);

    case GET_USERS_GROUPS_SUCCESS: {
      const updatedUsers = state.get('users').map(user =>
        user.id === action.actionMetadata.userId
          ? { ...user, groups: action.response.groups }
          : user
      );
      const selectedUser = state.get('selectedUser');
      const updatedSelectedUser = selectedUser && selectedUser.id === action.actionMetadata.userId
        ? { ...selectedUser, groups: action.response.groups }
        : selectedUser;
      return state.set('users', updatedUsers).set('selectedUser', updatedSelectedUser);
    }
    case GET_USER_PATIENT_INFO_SUCCESS: {
      const updatedUsers = arrayPatch(state.get('users'), { simplifedPatientId: action.actionMetadata.patientId }, () => ({ patientInfo: action.response.patient }));
      const selectedUser = state.get('selectedUser');
      const updatedSelectedUser = selectedUser && selectedUser.simplifedPatientId === action.actionMetadata.patientId
        ? { ...selectedUser, patientInfo: action.response.patient }
        : selectedUser;
      return state.set('users', updatedUsers).set('selectedUser', updatedSelectedUser);
    }
    case TOGGLE_USER_FLAG_SUCCESS: {
      const updatedUsers = arrayPatch(state.get('users'), { id: action.actionMetadata.userId }, (user) => ({ [action.actionMetadata.flagName]: !user[action.actionMetadata.flagName] }));
      return state.set('users', updatedUsers).set('isToggling', false);
    }

    case TOGGLE_USER_FLAG_REQUEST:
      return state.set('isToggling', true);
    case CLEAR_USER_ACCESS_CODE_SUCCESS: {
      const updatedUsers = arrayPatch(state.get('users'), { id: action.actionMetadata.userId },() => ({ accesCodes: [] }));
      return state.set('users', updatedUsers);
    }

    case REMOVE_SIMPLIFED_PATIENT_ID_SUCCESS: {
      const updatedUsers = arrayPatch(state.get('users'), { id: action.actionMetadata.userId }, () => ({ simplifedPatientId: null, patientInfo: null }));
      const selectedUser = state.get('selectedUser');
      const updatedSelectedUser = selectedUser && selectedUser.id === action.actionMetadata.userId
        ? { ...selectedUser, simplifedPatientId: null, patientInfo: null }
        : selectedUser;
      return state.set('users', updatedUsers).set('selectedUser', updatedSelectedUser);
    }

    case DELETE_USER_SUCCESS: {
      const updatedUsers = [...state.get('users')].filter(user => user.id !== action.actionMetadata.userId);
      return state.set('users', updatedUsers);
    }

    default:
      return state;
  }
}
